import TopNDropdownItem from "../../../table-actions-panel/models/selection-dropdown-item/TopNDropdownItem/TopNDropdownItem";

export default class TopNWebsitesSelectionItem extends TopNDropdownItem {
    getSelectedTranslation() {
        return {
            key: "si.table-actions-panel.options.websites.top-n.selected",
            replacements: {
                n: this.formatValue(),
            },
        };
    }
}
